import React from 'react';
import './MobileSkeleton.css';

const MobileSkeleton = ({ 
  variant = 'text', 
  lines = 1, 
  width, 
  height, 
  className = '',
  animate = true 
}) => {
  const getSkeletonContent = () => {
    switch (variant) {
      case 'text':
        return (
          <div className={`skeleton-text ${className}`}>
            {Array.from({ length: lines }, (_, i) => (
              <div
                key={i}
                className="skeleton-line"
                style={{
                  width: width || (i === lines - 1 ? '60%' : '100%'),
                  height: height || '16px'
                }}
              />
            ))}
          </div>
        );
      
      case 'card':
        return (
          <div className={`skeleton-card ${className}`}>
            <div className="skeleton-card-header">
              <div className="skeleton-avatar" />
              <div className="skeleton-card-title">
                <div className="skeleton-line" style={{ width: '70%', height: '16px' }} />
                <div className="skeleton-line" style={{ width: '40%', height: '12px' }} />
              </div>
            </div>
            <div className="skeleton-card-content">
              <div className="skeleton-line" style={{ width: '100%', height: '14px' }} />
              <div className="skeleton-line" style={{ width: '85%', height: '14px' }} />
            </div>
            <div className="skeleton-card-actions">
              <div className="skeleton-button" />
              <div className="skeleton-button" />
              <div className="skeleton-button" />
            </div>
          </div>
        );
      
      case 'list':
        return (
          <div className={`skeleton-list ${className}`}>
            {Array.from({ length: lines }, (_, i) => (
              <div key={i} className="skeleton-list-item">
                <div className="skeleton-checkbox" />
                <div className="skeleton-list-content">
                  <div className="skeleton-line" style={{ width: '80%', height: '16px' }} />
                  <div className="skeleton-line" style={{ width: '60%', height: '12px' }} />
                </div>
                <div className="skeleton-list-actions">
                  <div className="skeleton-button" />
                  <div className="skeleton-button" />
                </div>
              </div>
            ))}
          </div>
        );
      
      case 'button':
        return (
          <div className={`skeleton-button ${className}`} style={{ width, height: height || '44px' }} />
        );
      
      case 'avatar':
        return (
          <div className={`skeleton-avatar ${className}`} style={{ width, height: height || '40px' }} />
        );
      
      case 'form':
        return (
          <div className={`skeleton-form ${className}`}>
            <div className="skeleton-form-field">
              <div className="skeleton-label" />
              <div className="skeleton-input" />
            </div>
            <div className="skeleton-form-field">
              <div className="skeleton-label" />
              <div className="skeleton-input" />
            </div>
            <div className="skeleton-form-field">
              <div className="skeleton-label" />
              <div className="skeleton-textarea" />
            </div>
            <div className="skeleton-form-actions">
              <div className="skeleton-button" style={{ width: '120px', height: '48px' }} />
              <div className="skeleton-button" style={{ width: '80px', height: '48px' }} />
            </div>
          </div>
        );
      
      default:
        return (
          <div className={`skeleton-default ${className}`} style={{ width, height }} />
        );
    }
  };

  return (
    <div className={`skeleton ${animate ? 'animate' : ''} skeleton-${variant}`}>
      {getSkeletonContent()}
    </div>
  );
};

export default MobileSkeleton;
